module.exports = __webpack_public_path__ + "img/8.a7773450.png";